import styles from '~/styles/molecules/header/header_organaization.module.scss'

import { ChildProps } from '~/common/define/props'
import { addClass } from '~/common/utils/html'

interface Props extends ChildProps {
  name: string
  isOrigin: boolean
}

const OrganizationHeaderName = ({name, isOrigin, children}: Props) => {
  return (
    <div className={styles.headerOrganization__name + addClass(styles.origin, isOrigin)}>
      {children}
      <p>{name}</p>
    </div>
  )
}

export default OrganizationHeaderName